import type { ReactElement } from 'react'
import { useCallback, useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import ModalContext from 'contexts/ModalContext'
import LandingPageLoyaltyStayUpgradeBenefitsModal from './LandingPageLoyaltyStayUpgradeBenefitsModal'

interface Props {
  layout: 'tile' | 'row'
  benefitLabel: ReactElement
}

function LandingPageLoyaltyStayUpgrade(props: Props) {
  const { layout, benefitLabel } = props
  const showModal = useContext(ModalContext)
  const intl = useIntl()
  const image = useMemo<App.Image>(() => ({
    id: 'wfzka1j5ru5d5e7hc9u',
    title: intl.formatMessage({
      id: '1BIZ34jMRV4vOcu7M2Yj',
      defaultMessage: 'Free room upgrades',
      description: 'Alternative text fallback for the room upgrade loyalty benefit image',
    }),
  }), [intl])

  const handleDetailsClick = useCallback(() => {
    showModal(<LandingPageLoyaltyStayUpgradeBenefitsModal image={image} />)
  }, [image, showModal])

  return <LandingPageLoyaltyBenefitTile
    layout={layout}
    benefitType="hotel_upgrade"
    heading={intl.formatMessage({
      defaultMessage: 'Free room or package upgrades',
      id: '-jf0-fEIahxd0huyr3Zg',
      description: 'Heading for loyalty stay upgrade benefit tile component',
    })}
    subtitle={benefitLabel}
    onClick={handleDetailsClick}
  />
}

export default LandingPageLoyaltyStayUpgrade
